module.exports = __webpack_public_path__ + "c_static/img/2-1淘宝-加购物车.9e253f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/电脑端轨迹加权/2-1淘宝-加购物车.jpg
// module id = Euaj
// module chunks = 33